import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CsAgentAuthService } from '@spartacus/asm/root';
import {
  CURRENCY_CONTEXT_ID,
  ClientTokenService,
  CurrencyService,
  LANGUAGE_CONTEXT_ID,
  LanguageService,
  OCC_USER_ID_ANONYMOUS,
  OccEndpointsService,
  SiteContextConfig,
  UserIdService,
  getContextParameterDefault,
} from '@spartacus/core';
import { Observable, of } from 'rxjs';
import { take } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { StorageService } from '../service/storage/storage.service';
import { ASM_ENABLED_LOCAL_STORAGE_KEY } from '../spartacus/features/asm/asm-constant';

@Injectable({ providedIn: 'root' })
export class SiteContextInterceptor implements HttpInterceptor {
  activeLang: string;
  activeCurr: string;
  userCurrent$: Observable<string> = this.auth.getUserId();
  asmEnabled: any = null;
  urlsToNotUse: Array<string>;
  activeCurrency: string;

  private occSitesConfigLoaderEndpoint =
    // tslint:disable-next-line: max-line-length
    'basesites?fields=baseSites(uid,defaultLanguage(isocode),urlEncodingAttributes,urlPatterns,stores(currencies(isocode),defaultCurrency(isocode),languages(isocode),defaultLanguage(isocode)))';

  private cmsComponentsEndpoint = 'cms/components?fields=DEFAULT';
  private siteContextsEndpoint = 'site-contexts';
  b2bUserCurrent: any;

  constructor(
    private languageService: LanguageService,
    private currencyService: CurrencyService,
    private occEndpoints: OccEndpointsService,
    protected auth: UserIdService,
    protected clientToken: ClientTokenService,
    private config: SiteContextConfig,
    private storageService: StorageService,
    private asmAuthService: CsAgentAuthService
  ) {
    this.activeLang = getContextParameterDefault(this.config, LANGUAGE_CONTEXT_ID);
    this.activeCurrency = getContextParameterDefault(this.config, CURRENCY_CONTEXT_ID);

    this.languageService.getActive().subscribe((lang) => (this.activeLang = lang));
    this.currencyService.getActive().subscribe((curr) => {
      this.activeCurrency = curr;
    });

    this.urlsToNotUse = [this.occSitesConfigLoaderEndpoint, this.siteContextsEndpoint];
  }

  get userCurrent(): string {
    let userCurrent: string;
    this.userCurrent$.pipe(take(1)).subscribe((userId) => {
      if (userId === OCC_USER_ID_ANONYMOUS) {
        this.currencyService.setActive('USD');
        this.storageService.setSessionStorageItem('currency', 'USD');
        this.storageService.removeLocalStorageItem('userCurrency');
        this.storageService.removeSessionStorageItem('userCurrencySym');
      } else {
        this.asmEnabled = this.storageService.getLocalStorageItem(ASM_ENABLED_LOCAL_STORAGE_KEY);
        let userCurrency = this.storageService.getLocalStorageItem('userCurrency');

        if (this.asmEnabled) {
          this.currencyService.setActive(userCurrency);
        }
      }

      return (userCurrent = userId);
    });

    return userCurrent;
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let selectedShimanoSessionB2BUnit = this.storageService.getLocalStorageItem('shimanoSessionB2BUnit');
    const targetApiEndpoint = '/carts?';
    if (this.isValidRequestForInterceptor(request.url)) {
      if (request.url.includes(this.occEndpoints.getBaseUrl())) {
        if (this.userCurrent !== 'anonymous' && this.userCurrent !== 'current') {
          this.asmEnabled = this.storageService.getLocalStorageItem(ASM_ENABLED_LOCAL_STORAGE_KEY);
        }

        // 4.3 Fix if currency is null
        let userCurrency =
          this.storageService.getLocalStorageItem('userCurrency') !== null
            ? this.storageService.getLocalStorageItem('userCurrency')
            : this.storageService.getSessionStorageItem('currency');
        this.activeCurrency = userCurrency;
        this.currencyService.setActive(this.activeCurrency);
        if (this.activeCurrency !== null && this.activeCurrency !== '') {
          this.currencyService.setActive(this.activeCurrency);
        }
        if (
          this.asmEnabled &&
          this.userCurrent !== 'current' &&
          this.userCurrent !== 'anonymous' &&
          this.userCurrent !== null &&
          request.url.includes(targetApiEndpoint)
        ) {
          const url = this.occEndpoints.getBaseUrl();
          const baseSiteId = url.split('/occ/v2/')[1];
          const getActiveUser = this.userCurrent.split(':');
          const getCurrentUserBaseSite =
            'shimano' + getActiveUser[0].charAt(0).toUpperCase() + getActiveUser[0].slice(1) + '-' + getActiveUser[1];
          if (getCurrentUserBaseSite !== baseSiteId) {
            const emptyResponse = new HttpResponse({ body: {} });
            return of(emptyResponse);
          }
        }

        if (
          this.asmEnabled &&
          this.userCurrent !== 'current' &&
          this.userCurrent !== 'anonymous' &&
          this.userCurrent !== null &&
          !request.url.includes(this.occSitesConfigLoaderEndpoint) &&
          this.asmAuthService.isCustomerEmulated()
        ) {
          request = request.clone({
            setParams: {
              lang: this.activeLang,
              curr: this.activeCurrency,
              asmUser: this.userCurrent,
              ...(selectedShimanoSessionB2BUnit && { shimanoSessionB2BUnit: selectedShimanoSessionB2BUnit }),
            },
          });
        } else {
          request = request.clone({
            setParams: {
              lang: this.activeLang,
              curr: this.activeCurrency,
              ...(selectedShimanoSessionB2BUnit && { shimanoSessionB2BUnit: selectedShimanoSessionB2BUnit }),
            },
          });
        }
      }
    }
    return next.handle(request);
  }

  private isValidRequestForInterceptor(requestUrl: string): boolean {
    let positionIndicator: string = environment.prefix;
    let position = requestUrl.indexOf(positionIndicator);
    if (position > 0) {
      let destination: string = requestUrl.substr(position + positionIndicator.length);
      for (let address of this.urlsToNotUse) {
        if (address === destination) {
          return false;
        }
      }
    }
    return true;
  }
}
